import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Orthopedist icon
 *
 * @category Medical
 */
const Orthopedist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M23.393 18.721c-.98-.07-1.09-1.323-1.42-2.02-.17-.358-.35-.606-.71-.756-.6-.268-1.46-.597-1.4-1.393.04-.507.43-.875.75-1.224.23-.248.42-.467.63-.776.45-.726 1.21-1.542 2.15-.835 1.23 1.114 1.57 3.631 1.28 5.253-.12.647-.46 1.732-1.27 1.761h-.01zm-.39-2.378c.15.339.3.836.45 1.174.02.03.14-.278.15-.308.48-1.313.26-3.144-.26-4.368a3 3 0 0 0-.34-.577c-.05-.06-.1-.12-.16-.13-.09.03-.89.806-1.19 1.125-.16.189-.83 1.005-.98 1.194-.02.03-.05.06-.04.08 0 .02.02.03.05.05.1.059.23.118.34.168.87.339 1.66.806 1.98 1.563zm-8.19-11.781c.35.398.73.737 1.13 1.095.52.497 1.02.796 1.74 1.005.96.258 1.93.736 2.5 1.552.7 1.005.88 2.348.47 3.512-.32.846-.69 1.622-1.3 2.349-.56.686-1.43.905-2.34.935-.48.03-.84.299-1.19.597-.56.488-1.17.846-2.02.876h-.01c-1-.04-2.02-.647-2.6-1.433-.3-.418-.43-.876-.5-1.324-.12-.776-.01-1.552-.14-2.328-.22-1.274-1.26-3.065-2.11-4.12-.74-.776-1.5-1.631-2.31-2.348-.56-.428-1.26-.885-1.85-1.303-.3-.21-.59-.408-.87-.617h1.93c.27.17.55.348.75.478.47.318.92.626 1.31 1.044.64.667 1.33 1.354 1.93 2.02.71.856 1.21 1.742 1.65 2.617.24.498.39.995.54 1.552.27.946.13 2.349.25 3.294.08.637.52 1.164 1.1 1.483.65.348 1.16.408 1.85-.03.32-.22.62-.936.96-1.145.35-.238.74-.358 1.12-.408.25-.04.52-.04.76-.07.33-.049 1.08-.208 1.31-.487.53-.627.86-1.373 1.1-2.01.29-.846.15-1.86-.37-2.577-.57-.756-1.5-.776-2.4-1.104-.86-.339-1.56-.667-2.3-1.334-.34-.298-.63-.587-.93-.925L11.833 3h1.56c.54.597 1.03 1.134 1.41 1.552zm2.51 11.553c1.86-.548 3.77.427 4.35 2.348.23.706.17 1.433-.02 2.12-.1.397-.24.785-.36 1.173-.2.747-.29 1.463-.3 2.18.07.905.29 1.79.43 2.686.13.786.28 1.582.42 2.378h-1.11c-.13-.756-.25-1.522-.39-2.259-.14-.935-.38-1.86-.43-2.806.01-.835.44-1.95.67-2.835.24-.797.62-1.662.43-2.498-.39-1.592-1.92-2.299-3.36-1.672-.45.21-.85.548-1.3.757-1.02.537-2.68.427-3.66.945-.43.179-.8.587-.99 1.045-.28.706.06 1.572.48 2.189.23.328.39.497.63.826.38.507.73 1.094 1.04 1.631.44.687.68 1.473.88 2.26.15.556.33 1.104.44 1.65l.14.767h-1.02c-.03-.16-.06-.308-.08-.438-.16-.706-.39-1.443-.58-2.149-.13-.428-.27-.846-.5-1.234-.26-.438-.52-.905-.82-1.333-.33-.518-.73-.896-1.08-1.413a5 5 0 0 1-.59-1.214c-.5-1.453.28-3.045 1.61-3.602.88-.418 1.75-.348 2.64-.408.55-.03 1-.388 1.45-.667.29-.179.61-.348.97-.447z"
        />
      </svg>
    );
  }
);

Orthopedist.displayName = 'Orthopedist';

export { Orthopedist };
